import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";

var Config = require('../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.printDocument = this.printDocument.bind(this);

		this.state = {
			show: false,
			name:"",
			g_rh:"",
			birth:"",
			convoke_place:"",
			donation_type:"",
			register_date:"",
			register_hour:"",
			extraction_date:"",
			extraction_hour:"",
			medical_name:"",
			status:"",
			biometrics:[],
			vital_signs:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id, name, g_rh, birth){
		fetch(Config.default.apiGateway.URL+'offers/data_sheet?offers_id='+id,{
			method: 'GET',
			headers: new Headers({
				'Authorization'		: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'			: 'application/json',
				'Content-Type'		: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg) => {
					swal('error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var biometrics = [];
				response.biometrics.map((b)=>{
					var index = response.resp.biometrics_data.findIndex(obj =>
						obj.biometrics_id === b.id
					);

					if(index !== -1){
						biometrics.push({
							name: b.name,
							value: response.resp.biometrics_data[index].value
						});
					}else{
						biometrics.push({
							name: b.name,
							value: ""
						});
					}

					return b;
				});

				var vital_signs = [];
				response.vital_signs.map((b)=>{
					var index = response.resp.biometrics_data.findIndex( obj =>
						obj.biometrics_id === b.id
					);

					if(index !== -1){
						vital_signs.push({
							name: b.name,
							value: response.resp.biometrics_data[index].value
						});
					}else{
						vital_signs.push({
							name: b.name,
							value: ""
						});
					}

					return b;
				});

				this.setState({
					show: true,
					name:name,
					g_rh:g_rh,
					birth: birth,
					convoke_place:response.resp.convoke_place,
					donation_type:response.resp.donation_type,
					register_date:response.resp.register_date,
					register_hour:response.resp.register_hour,
					extraction_date:response.resp.extraction_date,
					extraction_hour:response.resp.extraction_hour,
					medical_name: response.resp.medical_name,
					status:response.resp.status,
					biometrics: biometrics,
					vital_signs: vital_signs
				});		

				
			}
		})

				
	}

	handleClose(){
		this.setState({
			show: false,
			name:"",
			g_rh:"",
			birth:"",
			convoke_place:"",
			donation_type:"",
			register_date:"",
			register_hour:"",
			extraction_date:"",
			extraction_hour:"",
			medical_name:"",
			status:"",
			biometrics:[],
			vital_signs:[],
		});
	}

	printDocument(){
		var doc = {content:[
			{text:this.state.name, alignment:'center', fontSize:18, bold:1, margin:[0,0,0,5]},
			{columns:[
				{text:'Fecha Nacimiento', alignment:'center', fontSize:12, bold:1},
				{text:'Grupo Donante', alignment:'center', fontSize:12, bold:1}
			], margin:[0,0,0,5]},
			{columns:[
				{text:this.state.birth, alignment:'center', fontSize:12},
				{text:this.state.g_rh, alignment:'center', fontSize:12},
			], margin:[0,0,0,5]},
			{columns:[
				{text:[
					{text:'Lugar de colecta: ', bold:1},
					{text:this.state.convoke_place}
				], fontSize:10},
				{columns:[
					{text:'Signos Vitales', bold:1},
					{text: 'Biometrias', bold:1}
				], fontSize:10},
			]},
			{columns:[
				{text:[
					{text:'Lugar de colecta: ', bold:1},
					{text:this.state.convoke_place}
				], fontSize:10},
			]},
			{columns:[
				{text:[
					{text:'Tipo donación: ', bold:1},
					{text:this.state.donation_type}
				], fontSize:10},
			]},
			{columns:[
				{text:[
					{text:'Fecha registro: ', bold:1},
					{text:this.state.register_date !== null ?
						moment(this.state.register_date).format('DD/MM/YYYY')+' '+
						moment(this.state.register_hour, 'H:mm:ss').format('HH:mm')
					: ""}
				], fontSize:10},
			]},
			{columns:[
				{text:[
					{text:'Fecha examen: ', bold:1},
					{text:this.state.extraction_date !== null ?
						moment(this.state.extraction_date).format('DD/MM/YYYY')+' '+
						moment(this.state.extraction_hour, 'H:mm:ss').format('HH:mm')
					: ""}
				], fontSize:10},
			]},
			{columns:[
				{text:[
					{text:'Médico: ', bold:1},
					{text:this.state.medical_name}
				], fontSize:10},
			]},
			{columns:[
				{text:[
					{text:'Estatus: ', bold:1},
					{text:this.state.status}
				], fontSize:10},
			]},
		]};

		this.state.vital_signs.map((v, i)=>{
			if(doc.content[4+i] !== undefined){
				doc.content[4+i].columns.push(
					{columns:[
						{text:[
							{text:v.name+':\t', bold:1},
							{text:v.value}
						]}
					], fontSize:10}
				)
			}else{
				doc.content.push({
					columns:[
						{text:''},
						{columns:[
							{text:[
								{text:v.name+':\t', bold:1},
								{text:v.value}
							]}
						], fontSize:10}
					]
				})
			}
			/**/
			return v;
		});

		this.state.biometrics.map((b, i)=>{
			if(doc.content[4+i] !== undefined){
				doc.content[4+i].columns[1].columns.push({
					text:[
						{text:b.name+':\t', bold:1},
						{text:b.value}
					]
				})
			}
			return b;
		})
		
		console.log(doc)

		pdfMake.createPdf(doc).download('Detalles.pdf');
		
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="lg" className="modal-history" show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>Detalles</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12">
							<div className="col-xs-12" style={{textAlign:"center"}}>
								<h3 className="color-font">{this.state.name}</h3>
							</div>
							<div className="col-xs-12 form-group" style={{textAlign:'center'}}>
								<div className="col-xs-12 col-sm-6">
									<h4>Fecha Nacimiento</h4>	<h4 className="color-font">{this.state.birth}</h4>
								</div>
								<div className="col-xs-12 col-sm-6">
									<h4>Grupo Donante</h4> <h4 className="color-font">{this.state.g_rh}</h4>
								</div>
							</div>
							<hr/>
							<div className="col-xs-12 col-sm-6">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-4" style={{textAlign:'right'}}>
										<label>Lugar de colecta</label>
									</div>
									<div className="col-xs-12 col-sm-6">
										<span>{this.state.convoke_place}</span>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-4" style={{textAlign:'right'}}>
										<label>Tipo donación</label>
									</div>
									<div className="col-xs-12 col-sm-6">
										<span>{this.state.donation_type}</span>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-4" style={{textAlign:'right'}}>
										<label>Fecha registro</label>
									</div>
									<div className="col-xs-12 col-sm-6">
										<span>
											{this.state.register_date !== null ?
												moment(this.state.register_date).format('DD/MM/YYYY')+' '+
												moment(this.state.register_hour, 'H:mm:ss').format('HH:mm')
											: ""}
										</span>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-4" style={{textAlign:'right'}}>
										<label>Fecha examen</label>
									</div>
									<div className="col-xs-12 col-sm-6">
										<span>
											{this.state.extraction_date !== null ?
												moment(this.state.extraction_date).format('DD/MM/YYYY')+' '+
												moment(this.state.extraction_hour, 'H:mm:ss').format('HH:mm')
											: ""}
										</span>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-4" style={{textAlign:'right'}}>
										<label>Médico</label>
									</div>
									<div className="col-xs-12 col-sm-6">
										<span>{this.state.medical_name}</span>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-4" style={{textAlign:'right'}}>
										<label>Estatus</label>
									</div>
									<div className="col-xs-12 col-sm-6">
										<span>{this.state.status}</span>
									</div>
								</div>
							</div>
							<div className="col-xs-12 col-sm-3">
								<div className="col-xs-12" style={{textAlign:'center'}}>
									<h4>Signos Vitales</h4>
								</div>
								{this.state.vital_signs.map((b, i)=>(
									<div className="col-xs-12 form-group" key={i}>
										<div className="col-xs-12 col-sm-6" style={{textAlign:'right'}}>
											<label>{b.name}</label>
										</div>
										<div className="col-xs-12 col-sm-5">
											<span>{b.value}</span>
										</div>
									</div>
								))}
							</div>

							<div className="col-xs-12 col-sm-3">
								<div className="col-xs-12" style={{textAlign:'center'}}>
									<h4>Biometricas</h4>
								</div>
								{this.state.biometrics.map((b, i)=>(
									<div className="col-xs-12 form-group" key={i}>
										<div className="col-xs-12 col-sm-6" style={{textAlign:'right'}}>
											<label>{b.name}</label>
										</div>
										<div className="col-xs-12 col-sm-5">
											<span>{b.value}</span>
										</div>
									</div>
								))}
							</div>
							
							
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.print')} 
						onClick={this.printDocument} /> 
					<FlatButton primary={true} label={t('content.generics.buttons.close')} 
						onClick={this.handleClose} /> 
				</Modal.Footer>
			</Modal>
		)
			
	}
}

export default translate('translations') (ModalDetails)